'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var BREAKPOINT_DEVICE_QUERY = 'query:device';
var BREAKPOINT_LANDSCAPE_QUERY = 'query:landscape';
var BREAKPOINT_DEVICE_UPDATED = 'device:updated';
var BREAKPOINT_LANDSCAPE_UPDATED = 'landscape:updated';
var BREAKPOINT_FULLSCREEN_UPDATED = 'fullscreen:updated';

exports.BREAKPOINT_DEVICE_QUERY = BREAKPOINT_DEVICE_QUERY;
exports.BREAKPOINT_DEVICE_UPDATED = BREAKPOINT_DEVICE_UPDATED;
exports.BREAKPOINT_FULLSCREEN_UPDATED = BREAKPOINT_FULLSCREEN_UPDATED;
exports.BREAKPOINT_LANDSCAPE_QUERY = BREAKPOINT_LANDSCAPE_QUERY;
exports.BREAKPOINT_LANDSCAPE_UPDATED = BREAKPOINT_LANDSCAPE_UPDATED;
